export default "__VITE_ASSET__RuETznvJ__"